export default {
  dbi_metric_mobile_cross_usage: 'Mobile Overlap',
  dbi_metric_mobile_cross_affinity: 'Overlap Affinity',
};
